import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContentElement } from '@urbannex/storethemes';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SectionBuilderStoreService } from '../../sections-editor/shared-section-builder/section-builder-store.service';
import { EditState } from '../../../model';
import { SectionEditorStoreService } from '../section-editor-dialog/section-editor-store.service';

@Component({
  selector: 'kve-font-family-popover',
  templateUrl: './font-family-popover.component.html',
  styleUrls: ['./font-family-popover.component.scss']
})
export class FontFamilyPopoverComponent implements OnInit {
  @Input() placeholder: string = 'Filter...';
  @Input() debounceMs: number = 300;
  @Output() filterChange = new EventEmitter<string>();

  filterControl = new FormControl('');

  service:string;
  
  fontFams = [
    {
      name:"Arial",
      value:"Arial, sans-serif"
    },
    {
      name:"Courier New",
      value:"Courier New, monospace"
    },
    {
      name:"Georgia",
      value:"Georgia, serif"
    },
    {
      name:"Lato",
      value:"Lato, sans-serif"
    },
    {
      name:"Lobster",
      value:"Lobster, sans-serif"
    },
    {
      name:"Merriweather",
      value:"Merriweather, sans-serif"
    },
    {
      name:"Montserrat",
      value:"Montserrat, sans-serif"
    },
    {
      name:"Open Sans",
      value:"Open Sans, sans-serif"
    },
    {
      name:"Oswald",
      value:"Oswald, sans-serif"
    },
    {
      name:"PT Sans",
      value:"PT Sans, sans-serif"
    },
    {
      name:"Playfair Display",
      value:"Playfair Display,serif"
    },
    {
      name:"Raleway",
      value:"Raleway, sans-serif"
    },
    {
      name:"Roboto",
      value:"Robotto, sans-serif"
    },
    {
      name:"Roboto Condensed",
      value:"Roboto Condensed, sans-serif"
    },
    {
      name:"Roboto Slab",
      value:"Roboto Slab, sans-serif"
    },
    {
      name:"Source Sans 3",
      value:"Source Sans 3, sans-serif"
    },
    {
      name:"Ubuntu",
      value:"Ubuntu, sans-serif"
    }
  ];
  filteredItems: any[] = [];
  content:ContentElement;
  title:string;

  currentValue;

  constructor(private cellEditorStoreService:CellEditorStoreService,
    private sectionBuilderStoreService:SectionBuilderStoreService,
    private sectionStore:SectionEditorStoreService
  ) { }

  ngOnInit(): void {
    this.service = this.service != undefined? this.service : "section"
    this.filterControl.valueChanges
      .pipe(
        debounceTime(this.debounceMs),
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.filterChange.emit(value || '');
      });
  }

  clearFilter() {
    this.filterControl.setValue('');
  }
  onBasicFilter(searchText: string) {

    if (!searchText) {
      this.filteredItems = [...this.fontFams];
      return;
    }

    this.filteredItems = this.fontFams.filter(item =>
      item.name.toLowerCase().includes(searchText.toLowerCase())
      // ||
      //item.category.toLowerCase().includes(searchText.toLowerCase())
    );
    console.log(this.filteredItems)
  }
  
  
  onSubmit(){
    //this.sectionEditorStoreService.updateMarginBottom(this.marginBottom);
  }

  onSelectFontFam(fontFam){
    this.sectionBuilderStoreService.updateEditState(EditState.EDITING)
    console.log(fontFam)
    let fontFamily = fontFam.value;
    this.content = {...this.content,fontFamily};
    //this.content = {...this.content,fontFamily};
    console.log({content:this.content,choice:fontFam,service:this.service});
    //this.content.fontFamily = fontFam.value;
    //Select the updating service
    if(this.service == "section" || this.service == "sectionBuilder" || this.service == "sectionEditorStoreService"){
      console.log("Content before service invocation:",this.content)
      if(this.content.name == "Title"){
        this.sectionStore.updateTitle(this.content)
      }else{
        this.sectionBuilderStoreService.updateContent(this.content);
      }
      this.sectionBuilderStoreService.updateEditState(EditState.UPDATED);  
      //Check if it's a title 
    }else if(this.service == "sectionStore"){
      console.log("SectionStore Service",this.content);
      this.sectionStore.updateTitle(this.content)
    }else{
      this.cellEditorStoreService.contentElements$.subscribe((contentElements:ContentElement[]) => {
        let contentElement = contentElements.find(element => element.elId == this.content.elId);
        contentElement.fontFamily = fontFam.value;
        this.cellEditorStoreService.updateContentElements(contentElements);
      })
    }
    //this.sectionBuilderStoreService.updateEditState(EditState.UPDATED);  
  }
}
